import { Chip, Tooltip, Zoom } from '@mui/material'
import React from 'react'

interface ComponentArgs {
  code: string
  name: string
}

const CurrencyCodeChip: React.FC<ComponentArgs> = (args: ComponentArgs) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (args.code === 'ZAR') {
    color = 'success'
    variant = 'outlined'
  } else if (args.code === 'USD') {
    color = 'secondary'
    variant = 'outlined'
  } else if (args.code === 'EUR') {
    color = 'warning'
    variant = 'outlined'
  } else if (args.code === 'GBP') {
    color = 'warning'
    variant = 'outlined'
  } else if (args.code === 'XBT' || args.code === 'BTC') {
    color = 'primary'
    variant = 'outlined'
  }

  return (
  <Tooltip title={args.name} TransitionComponent={Zoom} arrow placement='bottom'>
    <Chip label={args.code} variant={variant} color={color} />
  </Tooltip>
  )
}

export default CurrencyCodeChip
